export const AREA = 'area';
export const BAR_ENGINE_UTILIZATION = 'bar-engine-utilization';
export const BAR_FUEL_UTILIZATION = 'bar-fuel-utilization';
export const BOOLEAN = 'boolean';
export const CAN_SCAN = 'scan';
export const COLUMN_GRAPH = 'column-graph';
export const COMMAND = 'command';
export const GAUGE = 'gauge';
export const GAUGE_RANGE = 'gauge-range';
export const HIGH_BAR = 'high-bar';
export const IMAGE = 'image';
export const LINE_GRAPH = 'line-graph';
export const LINE_HIGH_CHART = 'line-high-chart';
export const LOCATION = 'location';
export const MAINTENANCE = 'maintenance';
export const MAP = 'map';
export const PIE = 'pie';
export const TEXT = 'text';
export const TEXT_ENGINE = 'text-engine';
export const TEXT_FUEL = 'text-fuel';
export const TEXT_STATIC = 'text-static';
export const TEXT_TAGS = 'text-tags';
export const VERTICAL_COLUMN_GRAPH = 'vertical-column-graph';

export const MIN_MAX_TYPE_SET = new Set([
  AREA,
  COLUMN_GRAPH,
  HIGH_BAR,
  LINE_GRAPH,
  VERTICAL_COLUMN_GRAPH,
]);
export const HISTORICAL_UTILIZATION_TYPES = new Set([
  BAR_ENGINE_UTILIZATION,
  BAR_FUEL_UTILIZATION,
]);
